import Reveal from "./Reveal";

const BADGES = [
  { img: "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/f5d14667-4c1d-4d18-90b3-049e6478ce50/Happiness+Guarentee.png", title: "HAPPINESS GUARANTEE", text: "Customer satisfaction comes first. If you're not happy, we're not done." },
  { img: "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/1f164f84-01de-4d19-8c41-1d4df4038cca/Lifetime+labour+%282%29.png", title: "LIFETIME LABOUR", text: "A lifelong workmanship warranty you can actually trust." },
  { img: "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/ebd37bf3-eef6-4679-9a45-1dc128950747/Upfront+%26+Fair+%282%29.png", title: "UPFRONT & FAIR", text: "Prices published online because we know they're fair." },
  { img: "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/173a903b-813f-451a-a3e5-fbfc37ab0408/Same+or+next+day+%287%29.png", title: "SAME / NEXT DAY", text: "Live availability — book the slot that suits you online." },
];

const TEAM_IMG = "https://images.squarespace-cdn.com/content/v1/6965e36e5a06e032300a47b8/8ff30e2c-53de-475c-b6f6-c431cfdbf285/GOOGLE+REVIEWS+%281%29.png";

export default function TrustBento() {
  return (
    <section className="bg-tpeco-smoke py-20 sm:py-28" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center flex flex-col items-center">
          <span className="chip-brutal bg-tpeco-blue border-tpeco-blue text-white">WHY US? THAT'S EASY…</span>
          <h2 className="mt-4 font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" data-testid="trust-heading">
            PERTH TRUSTS US WITH<br /><span className="bg-tpeco-pink text-white px-3 rounded-2xl inline-block">THE HOT STUFF</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BADGES.map((b, i) => (
            <Reveal key={b.title} i={i} className="card-brutal p-6 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-150" data-testid={`trust-badge-${i}`}>
              <img src={b.img} alt={b.title} className="h-20 w-auto object-contain" />
              <h3 className="mt-4 font-display uppercase text-2xl">{b.title}</h3>
              <p className="mt-2 text-sm font-semibold text-neutral-600">{b.text}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid lg:grid-cols-12 gap-6 lg:max-w-3xl lg:mx-auto">
          <Reveal className="lg:col-span-7 card-brutal" data-testid="team-card">
            <img src={TEAM_IMG} alt="The Plumbing & Electrical Co team in Perth" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal i={1} className="lg:col-span-5 card-brutal !bg-tpeco-blue text-white p-6 lg:p-5 flex flex-col justify-center text-center items-center" data-testid="licence-card">
            <div>
              <span className="chip-brutal bg-white border-white text-tpeco-blue">FULLY LICENSED</span>
              <h3 className="mt-4 lg:mt-3 font-display uppercase text-3xl lg:text-2xl">PLUMBERS +<br />ELECTRICIANS<br />UNDER ONE ROOF</h3>
              <p className="mt-3 lg:mt-2 text-sm lg:text-xs font-semibold text-white/85">
                Your electric swap is connected by a qualified electrician — not a plumber with a screwdriver.
                Gas work by licensed gas fitters. Every time.
              </p>
            </div>
            <div className="mt-3 space-y-1 text-xs font-bold uppercase tracking-widest text-white/80" data-testid="licence-numbers">
              <p>PL LICENCE: PL 8061</p>
              <p>EC LICENCE: EC 17738</p>
              <p>GF LICENCE: GL 013140</p>
              <p>BFL LICENCE: BFL 2246</p>
              <p>ABN: 16 623 157 067</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
